import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import qs from 'query-string';
import { getByRefAction } from '../../../store';
import { Loader } from '@bottomless/common/components';
import { SlugCategoryManifest } from '../../../../components/CategoryManifest';
import { Categories } from '@bottomless/common/constants';
import { CoffeeInvitation } from '../manifest/CoffeeInvitation';
import { PetFoodInvitation } from '../manifest/PetFoodInvitation';

const COMPONENTS = {
  CoffeePublicReferral: CoffeeInvitation,
  PetFoodPublicReferral: PetFoodInvitation,
};

const InvitationComponent = ({ getByRef, ...props }) => {
  const [referrer, setReferrer] = useState(null);
  const history = useHistory();

  const { location } = window;
  const paths = location.pathname.split('/');

  let referralId;
  if (paths && paths.length && paths[2]) {
    // eslint-disable-next-line prefer-destructuring
    referralId = paths[2];
  } else {
    // eslint-disable-next-line prefer-destructuring
    referralId = qs.parse(window.location.search).referralId;
  }

  useEffect(() => {
    (async () => {
      const { payload, error } = await getByRef(referralId);

      if (error) {
        if (payload.status === 404) {
          return history.push('/');
        }
      }

      setReferrer(payload);
    })();
  }, [getByRef, history, referralId]);

  const isCoffee = useMemo(() => referrer?.product.category.slug === Categories.Coffee, [referrer]);

  return referrer ? (
    <SlugCategoryManifest
      manifestKey="publicReferral"
      components={COMPONENTS}
      noLoading
      slug={referrer.product.category.slug}
      isCoffee={isCoffee}
      referrer={referrer}
      {...props}
    />
  ) : (
    <div className="referral-loader mt-5 mb-4">
      <Loader size="40px" />
    </div>
  );
};

InvitationComponent.propTypes = {
  getByRef: PropTypes.func.isRequired,
};

export const Invitation = withRouter(
  connect(
    () => {},
    dispatch => ({
      getByRef: ref => dispatch(getByRefAction(ref)),
    })
  )(InvitationComponent)
);
